<template>
  <div id="UserGuide">
    <div class="notice-right">

      <div style="font-family:'Adobe Heiti Std';height:45px;font-size:24px;color:#707070;padding:23px 0  0 10px;">用户指南Q&A</div>
      <div class="notice-right-content-box">
        <div class="font-top" style="margin-bottom:7px;"></div>
        <div style="height:279px;overflow: hidden;">
          <div class="guide-box">
            <div class="guide-row">
              <div class="guide-pic">
                <img src="../../assets/img/project-default.jpg">
              </div>
              <div class="guide-describe">
                1. 用户注册：供应商可自行注册，由平台审核。采购方请与平台联系，完成实名认证后即可开展业务。
              </div>
            </div>
            <div class="guide-row">
              <div class="guide-pic">
                <img src="../../assets/img/project-default.jpg">
              </div>
              <div class="guide-describe">
                2. 绑定微信：有两大好处，一是微信扫码即可登录，二是关注“ 易比得 ”公众号后，可收到项目动态通知。
              </div>
            </div>
            <div class="guide-row">
              <div class="guide-pic">
                <img src="../../assets/img/project-default.jpg">
              </div>
              <div class="guide-describe">
                3. 报价要提交：供应商报价后，先预览进行检查，然后一定要提交，提交，提交，重要的事情说三遍！
              </div>
            </div>

          </div>
        </div>
        <div class="font-bottom" style="margin-top:7px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'UserGuide',
  mounted() {
    this.init();
  },
  methods: {
    init: function() {
      // 用户指南动画效果
      var count = 0;

      $('.font-bottom').click(function() {
        var height = $('.guide-box').height();
        count--;
        if (Math.abs(268 * count) < height) {
          $('.guide-box').animate({ 'margin-top': 268 * count });
        } else {
          count++;
        }
      });
      $('.font-top').click(function() {
        count++;
        if (count <= 0) {
          $('.guide-box').animate({ 'margin-top': 268 * count });
        } else {
          count--;
        }
      });

      $('.notice-right-content-box').on('mouseenter', function() {
        $('.font-top').animate({ opacity: 1 }, 100);
        $('.font-bottom').animate({ opacity: 1 }, 100);
      });
      $('.notice-right-content-box').on('mouseleave', function() {
        $('.font-top').animate({ opacity: 0 }, 100);
        $('.font-bottom').animate({ opacity: 0 }, 100);
      });
    }
  }
};
</script>
<style scoped lang="less">
#UserGuide {
  .notice-right {
    height: 385px;
    width: 374px;
    float: left;
  }
  .notice-right .font-top {
    height: 11px;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    background: #efefef url(../../assets/img/font-top.jpg) no-repeat center center;
  }
  .notice-right .font-bottom {
    height: 11px;
    width: 100%;
    opacity: 0;
    cursor: pointer;
    background: #efefef url(../../assets/img/font-bottom.jpg) no-repeat center center;
  }
  .notice-right .guide-row {
    height: 56px;
    width: 354px;
    margin: 0 auto;
    margin-bottom: 24px;
    padding-top: 15px;
  }
  .notice-right .guide-pic {
    height: 56px;
    width: 112px;
    margin-right: 16px;
    display: flex;
    overflow: hidden;
    float: left;
  }
  .notice-right .guide-pic img {
    max-width: 112px;
    max-height: 52px;
    margin: auto;
  }
  .notice-right .guide-describe {
    font-family: 'Microsoft YaHei';
    float: left;
    font-size: 14px;
    color: #8e8e8e;
    height: 56px;
    width: 226px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .notice-right .guide-describe:hover {
    color: #030303;
  }
}
</style>
